  <div *ngIf="claimSettlementDO" class="flexie-auto-grid">
    <!-- Credit -->
    <div>
      <h2 class="col-green text-a-center f-s-1-5r p-b-20"><i nz-icon nzType="dollar"></i> Credit</h2>
      <div class="grid grid-gap-10 grid-2x p-r-20" style="border-right:1px dashed #999">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Benefit Amount</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.benefitAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Paid Up Value</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.settledAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Surrender Value</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text" nz-input
                disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Advance Premium</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.advancePremAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
    <!-- Debit -->
    <div class="p-l-0">
      <h2 class="col-red text-a-center f-s-1-5r p-b-20"><i nz-icon nzType="dollar"></i> Debit</h2>
      <div class="grid grid-gap-10 grid-2x">
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Outstanding Premium</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.outstandingPremAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Interest</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.interestAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
        <nz-form-item>
          <nz-form-label [nzSpan]="24">Penalty</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.penaltyAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Loan Amount</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.loanAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSpan]="24">Unpaid premium</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text" nz-input
                disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSpan]="24">Interest on unpaid premium</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text" nz-input
                disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSpan]="24">Policy loan</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text" nz-input
                disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSpan]="24">Stamp duty</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.stampDutyAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>


        <nz-form-item>
          <nz-form-label [nzSpan]="24">GST</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text" nz-input
                disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Legal fees</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.legalFeesAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Investigator fees</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text"
                [ngModel]="claimSettlementDO.investigationFeesAmt" nz-input disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24">Bonus</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-input-group [nzAddOnBefore]="appMetadataHandler.baseCurrencyMiniPREFIX"><input type="text" nz-input
                disabled /></nz-input-group>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div>
  </div>
